import script from "./ChartUploadFileComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChartUploadFileComponent.vue?vue&type=script&setup=true&lang=ts"

import "./ChartUploadFileComponent.vue?vue&type=style&index=0&id=554a52b8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-554a52b8"]])

export default __exports__